/* eslint-disable import/namespace */
import * as components from "./components"

export * from "./components"

export default {
	install(app) {
		for (const componentKey in components) {
			const component = components[componentKey]
			//一些 hooks 和 数据并不需要 install
			if (component && component.install) {
				app.use(component)
			}
		}
	},
}
